import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const menuItem: SxStyle = {
  justifyContent: 'center',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
};
